import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-details-ec.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-details-ec.component.scss?ngResource";
import { ViewApplicationDetailsEcConstants } from "./view-application-details-ec.constants";
import { ChangeDetectorRef, Component } from "@angular/core";
import { ViewApplicationBaseComponent } from "../../../shared/view-application-base/view-application-base.component";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { ApplicationViewService } from "../../../shared/application-view.service";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import { AppControllerService } from "../../../../app-controller.service";
import { RouterParamsService } from "../../../../shared/services/route-params.service";
import { CRUDOperation } from "../../../../shared/models/crud-operation-enum.model";
let ViewApplicationDetailsEcComponent = class ViewApplicationDetailsEcComponent extends ViewApplicationBaseComponent {
    applicationViewService;
    aflaModuleStrategyService;
    selectedApplicationService;
    appController;
    changeDetectorRefs;
    routerParamsService;
    // ViewApplicationDetailsEcConstants
    // Labels
    descriptionLabel = ViewApplicationDetailsEcConstants.DESCRIPTION_LABEL;
    applicationTypeLabel = ViewApplicationDetailsEcConstants.APPLICATION_TYPE_LABEL;
    whoIsApplyingLabel = ViewApplicationDetailsEcConstants.WHO_IS_APPLYING_LABEL;
    descriptionOfProposedWorkLabel = ViewApplicationDetailsEcConstants.DESCRIPTION_OF_PROPOSED_WORK_LABEL;
    descriptionOfProposedWorkNote = ViewApplicationDetailsEcConstants.DESCRIPTION_OF_PROPOSED_WORK_NOTE;
    phaseLabel = ViewApplicationDetailsEcConstants.PHASE_LABEL;
    conventionalPrepaidLabel = ViewApplicationDetailsEcConstants.CONVENTIONAL_PREPAID_LABEL;
    estimatedCapacityLabel = ViewApplicationDetailsEcConstants.ESTIMATED_CAPACITY_LABEL;
    // Form controls
    descriptionFormControlName = ViewApplicationDetailsEcConstants.DESCRIPTION_FORM_CONTROL_NAME;
    applicationTypeFormControlName = ViewApplicationDetailsEcConstants.APPLICATION_TYPE_FORM_CONTROL_NAME;
    applicantTypeFormControlName = ViewApplicationDetailsEcConstants.APPLICANT_TYPE_FORM_CONTROL_NAME;
    descriptionOfProposedWorkFormControlName = ViewApplicationDetailsEcConstants.DESCRIPTION_OF_PROPOSED_WORK_FORM_CONTROL_NAME;
    phaseFormControlName = ViewApplicationDetailsEcConstants.PHASE_FORM_CONTROL_NAME;
    paymentTypeControlName = ViewApplicationDetailsEcConstants.PAYMENT_TYPE_CONTROL_NAME;
    estimatedCapacityControlName = ViewApplicationDetailsEcConstants.ESTIMATED_CAPACITY_FORM_CONTROL_NAME;
    // constants
    validationMessages = ViewApplicationDetailsEcConstants.VALIDATION_MESSAGES;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    removeLabel = SharedConstants.REMOVE_LABEL;
    // variables
    detailsForm;
    applicationTypes = [];
    applicantTypes = [];
    phases = [];
    conventionalPrepaidOptions = [];
    getLookupsObservableSubscription;
    constructor(applicationViewService, aflaModuleStrategyService, selectedApplicationService, appController, changeDetectorRefs, routerParamsService) {
        super(applicationViewService, aflaModuleStrategyService, selectedApplicationService, routerParamsService);
        this.applicationViewService = applicationViewService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.appController = appController;
        this.changeDetectorRefs = changeDetectorRefs;
        this.routerParamsService = routerParamsService;
    }
    ngOnInit() {
        this.initForm();
        this.loadLookups();
        this.getMetadata();
    }
    initForm() {
        this.detailsForm = this.aflaModuleStrategyService.form.get("detailsForm");
        this.detailsForm.enable();
    }
    populateForm(application) {
        if (application && application.appId > 0)
            this.detailsForm.markAsTouched();
        else
            return;
        const applicationType = this.applicationTypes.find(x => x.code === application.applicationType);
        const applicantType = this.applicantTypes.find(x => x.code === application.applicantType);
        const phase = this.phases.find(x => x.code === application.phase);
        const paymentType = this.conventionalPrepaidOptions.find(x => x.code === application.paymentType);
        this.detailsForm.get(this.descriptionFormControlName).setValue(application.description);
        this.detailsForm.get(this.applicationTypeFormControlName).setValue(applicationType);
        this.detailsForm.get(this.applicantTypeFormControlName).setValue(applicantType);
        this.detailsForm.get(this.descriptionOfProposedWorkFormControlName).setValue(application.descriptionOfProposedWork);
        this.detailsForm.get(this.phaseFormControlName).setValue(phase);
        this.detailsForm.get(this.estimatedCapacityControlName).setValue(application.estimatedCapacity);
        this.detailsForm.get(this.paymentTypeControlName).setValue(paymentType);
    }
    loadLookups() {
        const params = {
            $filter: `(moduleId eq ${this.appController.selectedModuleID}) and ((name eq '${ViewApplicationDetailsEcConstants.APPLICATION_TYPE_LOOKUP_NAME}' and deleted eq false) or (name eq '${ViewApplicationDetailsEcConstants.APPLICANT_TYPE_LOOKUP_NAME}' and deleted eq false) or (name eq '${ViewApplicationDetailsEcConstants.PHASE_LOOKUP_NAME}' and deleted eq false) or (name eq '${ViewApplicationDetailsEcConstants.CONVENTIONAL_PREPAID_LOOKUP_NAME}' and deleted eq false))`
        };
        this.getLookupsObservableSubscription = this.applicationViewService
            .getLookupsObservable(params).subscribe({
            next: (response) => this.onGetLookupsCompleted(response),
            error: (error) => {
                this.appController.handleServerErrorMessage(ViewApplicationDetailsEcConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    onGetLookupsCompleted(response) {
        const applicationTypes = [];
        const applicantTypes = [];
        const phases = [];
        const conventionalPrepaid = [];
        if (response && response.value.length > 0) {
            response.value.forEach(item => {
                if (item.name === `${ViewApplicationDetailsEcConstants.APPLICATION_TYPE_LOOKUP_NAME}`) {
                    applicationTypes.push(JSON.parse(item.content));
                }
                if (item.name === `${ViewApplicationDetailsEcConstants.APPLICANT_TYPE_LOOKUP_NAME}`) {
                    applicantTypes.push(JSON.parse(item.content));
                }
                if (item.name === `${ViewApplicationDetailsEcConstants.PHASE_LOOKUP_NAME}`) {
                    phases.push(JSON.parse(item.content));
                }
                if (item.name === `${ViewApplicationDetailsEcConstants.CONVENTIONAL_PREPAID_LOOKUP_NAME}`) {
                    conventionalPrepaid.push(JSON.parse(item.content));
                }
            });
            this.aflaModuleStrategyService.lookups.set(`${ViewApplicationDetailsEcConstants.APPLICATION_TYPE_LOOKUP_NAME}`, applicationTypes);
            this.aflaModuleStrategyService.lookups.set(`${ViewApplicationDetailsEcConstants.APPLICANT_TYPE_LOOKUP_NAME}`, applicantTypes);
            this.aflaModuleStrategyService.lookups.set(`${ViewApplicationDetailsEcConstants.PHASE_LOOKUP_NAME}`, phases);
            this.aflaModuleStrategyService.lookups.set(`${ViewApplicationDetailsEcConstants.CONVENTIONAL_PREPAID_LOOKUP_NAME}`, conventionalPrepaid);
            this.applicationTypes = applicationTypes;
            this.applicantTypes = applicantTypes;
            this.phases = phases;
            this.conventionalPrepaidOptions = conventionalPrepaid;
            this.populateForm(this.selectedApplication);
            this.changeDetectorRefs.detectChanges();
        }
    }
    loadMetadata(stepMeta) {
    }
    handleRouteChange() {
    }
    static ctorParameters = () => [
        { type: ApplicationViewService },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: AppControllerService },
        { type: ChangeDetectorRef },
        { type: RouterParamsService }
    ];
};
ViewApplicationDetailsEcComponent = __decorate([
    Component({
        selector: "app-view-application-details-ec",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ViewApplicationDetailsEcComponent);
export { ViewApplicationDetailsEcComponent };
